module.exports = __webpack_public_path__ + "img/camp_shirt_other10.452dce1c.svg";